export class GenesisRouterConstants {

    public static RouteNames = {
        Home: "",
        Audits: "audits",
        Dashboard: "dashboard",
        ManageLookups: "lookups",
        ManageStatusReasonTransitions: "manage-status-reason-transactions",
        ManagePermissions: "permissions",
        ManageUsers: "users",
        ManageBranches: "manage-branches",
        ManageEntities: "manage-entities",
        Validations: "validations",
        ManageVersions: "versions",
        ManageScheduledMaintenances: "scheduled-maintenances",
        Login: "login",
        Register: "register",
        ForgotPassword: "forgot-password",
        ResetPassword: "resetPassword",
        ListVideoCalls: "list-video-calls",
        OnboardingRequest: "onboarding-request",
        Onboardings: "onboardings-list",
        OnboardingPlugins: "onboarding-plugins-list",
        PersistOnboarding: "persist-onboarding",
        ChangePassword: "change-password",
        ManageDashboards: "manage-dashboards",
        ManageQueries: "manage-queries",
        ManageUserDashboards: "manage-user-dashboards",
        PermissionDenied: "permission-denied",
        WorkflowConfiguration: "workflow-configuration",
        GdprPersonalDataRecord: "gdpr-personal-data-record",
        GdprPersonalDataRecordList: "gdpr-personal-data-record-list",
        GdprDataSubjectsList: "gdpr-data-subjects-list",
        GdprDataSubject: "gdpr-data-subject",
        GdprCasesList: "gdpr-cases-list",
        GdprCase: "gdpr-case",
        GdprPolicyManagement: "gdpr-policy-management",
        GdprPersonalDataRecordManagement: "gdpr-personal-data-record-management",
        GenericRedirectCallback: "redirect-callback",
        Auth0Login: "auth0-login",
        StatusCode404: "statuscode404",
        StatusCode401: "statuscode401",
        StatusCode403: "statuscode403"
    };
}
